export default "__VITE_ASSET__DJtH8leX__"